import getCountryByCode from './getCountryByCode';

// Reproduce logic from mobile app
const getCountryForTypeform = (country: string | undefined) => {
  if (country !== undefined) {
    const countryInfo = getCountryByCode({
      countryCode: country,
      // Force 'fr' locale to match Typeform language
      translationLanguage: 'fr',
    });

    if (countryInfo !== null) {
      return countryInfo.label;
    }
  }

  // country may not be a code, we used to stock `FR` instead of full country name so we return it as such
  return country;
};

export default getCountryForTypeform;
